import { render, staticRenderFns } from "./QuotationChangeStatusModal.vue?vue&type=template&id=480a21e6&"
import script from "./QuotationChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./QuotationChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./QuotationChangeStatusModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports